import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { ScheduleReportTable } from '../../report/ScheduleReportTable';
import { baseTotalColumns } from '../../groups/GroupedTotalsColumn';
import { GroupVisitsByAssignedToTable } from '../../groups/GroupVisitsByAssignedToTable';

const WeeklyTotalsAssignedToDataTable = createQueryDataTable('schedule-report-totals-assigned-to');
type RowType = RowOfQueryDataTable<typeof WeeklyTotalsAssignedToDataTable>;

const columnDefinitions = WeeklyTotalsAssignedToDataTable.columns([
	{
		header: 'Assigned To',
		key: 'assignedToName',
		sortable: true
	},
	...baseTotalColumns<RowType>()
]);

export function WeeklyTotalsAssignedToTable(props: PropsOfQueryDataTable<typeof WeeklyTotalsAssignedToDataTable>) {
	return (
		<GroupVisitsByAssignedToTable
			columnDefinitions={columnDefinitions}
			searchType="schedule-report-totals-assigned-to"
			tableComponent={ScheduleReportTable}
			{...props}
		/>
	);
}
